import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";
import { Button } from "./ui/button";

const DISMISS_KEY = "eximflow_install_dismissed";

export const InstallAppPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showIOS, setShowIOS] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY)) return;
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    if (standalone) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);

    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
    if (isIOS) {
      setShowIOS(true);
      setVisible(true);
    }
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem(DISMISS_KEY, "1");
  };

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") setVisible(false);
    setDeferredPrompt(null);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-16 lg:bottom-4 left-1/2 -translate-x-1/2 z-[90] w-[94%] max-w-md rounded-xl border border-slate-700 bg-slate-900 text-white shadow-2xl p-3 flex items-center gap-3"
      data-testid="install-app-banner"
    >
      <img src="/icon-192.png" alt="EximFlow" className="w-10 h-10 rounded-lg" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold">Install EximFlow</p>
        {showIOS && !deferredPrompt ? (
          <p className="text-[11px] text-slate-300 leading-snug">
            Tap <Share className="w-3 h-3 inline mx-0.5" /> Share, then{" "}
            <span className="font-medium">"Add to Home Screen"</span>
          </p>
        ) : (
          <p className="text-[11px] text-slate-300">Use it like an app — full screen, home icon</p>
        )}
      </div>
      {deferredPrompt && (
        <Button size="sm" onClick={install} className="h-8 gap-1 bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold" data-testid="install-app-btn">
          <Download className="w-3.5 h-3.5" /> Install
        </Button>
      )}
      <button onClick={dismiss} className="p-1 text-slate-400 hover:text-white" data-testid="install-dismiss-btn" aria-label="Dismiss">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
